import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './ui/App';
import { ErrorBoundary } from './ui/ErrorBoundary';
import { listenForInstall } from './app/fullscreen';
import { noTouchMenus } from './ui/noCallouts';
// Jersey 10 (SIL Open Font License), a pixel face for the whole game, served with the site: no
// font requests elsewhere.
import '@fontsource/jersey-10/400.css';
import './ui/pixel-frames.css';
import './ui/styles.css';
import './ui/theme-sea.css';
// The whole game in pixel art: after every other stylesheet.
import './ui/pixel-ui.css';
import './ui/horrors.css';

// The browser's offer to install the app can come before the first render: keep it.
listenForInstall();
noTouchMenus();

const root = document.getElementById('root');
if (!root) throw new Error('missing #root element');
createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
